import StagePosition from './StagePosition';
export default StagePosition
;